import { FunctionComponent } from 'react';

import { Button, Typography, Link, Accordion, AccordionDetails, 
  AccordionActions, AccordionSummary } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { PaymentMethod } from 'model/collection/CollectionModels';
import { TextBox } from 'components/common/TextBox';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {PAYPAL, CASH_APP, ZELLE, VENMO} from 'assets/Icons'

export const paymentMethodMeta: { [key: string]: PaymentMeta } = {};
paymentMethodMeta["paypal"] = {
  usernameTextBoxLabel: "Username",
  usernameTextBoxDecoration: "@",
  displayName: "PayPal",
  icon: PAYPAL(24),
  postText: (<>
    {"Requires PayPal.me, "}
    <Link color="inherit" rel="noopener noreferrer" href='https://www.paypal.com/paypalme/' target="_blank" tabIndex={-1} >
      {"click here"}
    </Link>
    {" to create one before continuing. Amount limitations apply, "}
    <Link color="inherit" rel="noopener noreferrer" target="_blank" tabIndex={-1} 
          href='https://www.paypal.com/us/cshelp/article/what%E2%80%98s-the-maximum-amount-i-can-send-with-my-paypal-account-help286'>
      click here to learn more
    </Link>
  </>)
}
// paymentMethodMeta["zelle"] = {
//   usernameTextBoxLabel: "Phone Number or Email",
//   usernameTextBoxDecoration: "@",
//   displayName: "Zelle",
//   icon: ZELLE(25),
//   postText: (<>
//     {"The user will have to enter the amount. Always check Zelle to ensure the right amount has been transfered. Amount limitations apply, "}
//     <Link color="inherit" rel="noopener noreferrer" target="_blank" tabIndex={-1} 
//           href='https://www.zellepay.com/faq/there-limit-how-much-money-i-can-send-or-receive'>
//       click here to learn more
//     </Link>
//   </>)
// }
paymentMethodMeta["cashapp"] = {
  usernameTextBoxLabel: "Cash Tag",
  usernameTextBoxDecoration: "$",
  displayName: "CashApp",
  icon: CASH_APP(25),
  postText: (<>
    {"The user will have to enter the amount. Always check CashApp to ensure the right amount has been transfered. Amount limitations apply, "}
    <Link color="inherit" rel="noopener noreferrer" href='https://cash.app/help/6543-account-limits' target="_blank" tabIndex={-1} >
      click here to learn more
    </Link>
  </>)
}
paymentMethodMeta["venmo"] = {
  usernameTextBoxLabel: "Username",
  usernameTextBoxDecoration: "@",
  displayName: "Venmo",
  icon: VENMO(25),
  postText: (<>
    {"Amount limitations apply, "}
    <Link color="inherit" rel="noopener noreferrer" href='https://help.venmo.com/cs/articles/personal-profile-payment-limits-vhel188' target="_blank" tabIndex={-1} >
      click here to learn more
    </Link>
  </>)
}

interface PaymentMeta {
  usernameTextBoxLabel: string;
  usernameTextBoxDecoration: string;
  displayName: string;
  icon: any;
  postText?: any;
}

export class PaymentMethodsProps {
  method: PaymentMethod;
  onDelete: (serviceName: string) => void;
  onChange: (element: any, serviceName: string, index: number) => void;
  onBlur: (element: any, serviceName: string, index: number) => void;
  violations: Map<any, any>;
  index: number;
}

const PaymentMethodComponent: FunctionComponent<PaymentMethodsProps> = 
  ({method, onDelete, onChange, onBlur, violations, index}) => {
  const meta: PaymentMeta = paymentMethodMeta[method.service];

  return (
    <Accordion defaultExpanded>
      <AccordionSummary sx={{minHeight: "0 !important", 
      '& .MuiAccordionSummary-content': {
        marginTop: "10px !important",
        marginBottom: "10px !important",
        '&.Mui-expanded': {
          marginTop: "10px !important",
          marginBottom: "10px !important",
        },
      }}} expandIcon={<ExpandMoreIcon/>} aria-controls="panel1-content">
        <span style={{
          color: violations?.get(`/paymentMethods/${index}/serviceUser`)? "#f44336" : "inherit",
          marginRight: "10px"
        }}>{meta.icon}</span>
        <Typography component="span" style={{
          color: violations?.get(`/paymentMethods/${index}/serviceUser`)? "#f44336" : "inherit",
        }}>{meta.displayName}</Typography>
      </AccordionSummary>
      <AccordionDetails>
        {method.service === "zelle" ?
          <Grid container spacing={{ xs: 0, sm: 2 }}>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextBox
                name="serviceUser"
                label="Email or Phone Number"
                value={method.serviceUser}
                error={violations?.get(`/paymentMethods/${index}/serviceUser`)||violations?.get(`/paymentMethods/${index}`)}
                onChange={(el: any) => onChange(el, method.service, index)}
                onBlur={(el: any) => onBlur(el, method.service, index)}
                maxLength={250}
                helpText="The service options" />
            </Grid>
            <Grid size={{ xs: 12, sm: 6 }}>
              <TextBox
                name="nameOfUser"
                label="Name"
                onChange={(el: any) => onChange(el, method.service, index)}
                onBlur={(el: any) => onBlur(el, method.service, index)}
                maxLength={250}
                value={method.nameOfUser}
                helpText="Name" />
            </Grid>
          </Grid>:
          <TextBox
            name="serviceUser"
            onChange={(el: any) => onChange(el, method.service, index)}
            onBlur={(el: any) => onBlur(el, method.service, index)}
            label={meta.usernameTextBoxLabel}
            value={method.serviceUser}
            error={violations?.get(`/paymentMethods/${index}/serviceUser`)||violations?.get(`/paymentMethods/${index}`)}
            icon={meta.usernameTextBoxDecoration}
            maxLength={250}
            helpText="The service options" />
        }
        {!meta.postText?<></>:<Typography variant='caption' color='inherit'>{meta.postText}</Typography>}
      </AccordionDetails>
      <AccordionActions sx={{justifyContent: "left"}}>
        <Button color="inherit" onClick={(e: any) => onDelete(method.service)}>Remove</Button>
      </AccordionActions>
    </Accordion>
  );
}
export default PaymentMethodComponent;